import { BookingState } from '@/models/www/store/BookingState';
import baseApi from "./api.service";

const authenticateService = {
	authenticate(id = ''): Promise<{ booking: BookingState }> {
		return baseApi.get<{ booking: BookingState }>(`auth?id=${id}`);
	}
}

export default authenticateService;